import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { CheckoutFormEmailField } from "./CheckoutFormEmailField";
import { CheckoutFormPasswordField } from "./CheckoutFormPasswordField";

export const CheckoutFormAccountFields = () => {
  const { currentUser } = usePaywallCheckoutContext();

  if (currentUser) {
    return null;
  }

  return (
    <>
      <CheckoutFormEmailField />
      <CheckoutFormPasswordField />
    </>
  );
};
